import { JSXElement, Show, Component } from 'solid-js';

import { onCopy } from '../../utils';

/**
 * LabelItem 组件属性接口
 */
interface LabelItemProps {
  /** 标签内容 */
  label: JSXElement;
  /** 显示值 */
  value: JSXElement | JSXElement[] | null;
  /** 是否可复制（仅当value为字符串时有效） */
  copyable?: boolean | string;
  /** 自定义CSS类名 */
  class?: string;
}

/**
 * 标签-值显示组件
 * 支持复制功能的键值对显示组件
 */
const LabelItem: Component<LabelItemProps> = (props) => {
  /**
   * 处理复制点击事件
   */
  const handleCopyClick = (event: MouseEvent): void => {
    event.stopPropagation();
    if (typeof props.copyable === 'string') {
      onCopy(props.copyable);
    } else if (props.copyable && typeof props.value === 'string') {
      onCopy(props.value);
    }
  };

  return (
    <Show when={props.value}>
      <div class="flex justify-between items-center">
        <div class="flex-none mr-10">{props.label}</div>
        <div
          class={`flex items-center gap-1 text-neutral-main1 break-all ${props.copyable ? 'cursor-pointer' : ''}`}
          onClick={handleCopyClick}
        >
          {props.value}
          <Show when={props.copyable}>
            <IconCopy class="size-4 cursor-pointer" role="button" />
          </Show>
        </div>
      </div>
    </Show>
  );
};

export default LabelItem;
